const SectionGroupieDrive = Class(
	/**
	 * @lends {SectionGiftCard#}
	 */
	{
		/** @param {DR.web.GetCrazyWolfSubmissions} */
		_mGet: null,
		_items: new Map(),
		__construct() {
			this.node = mkE({
				tag: 'div',
				id: 'SectionGroupieDrive'
			}).append(this.layout.ct());
		},
		draw() {
			mkE({
				tag: 'div',
				className: 'container file_explorer',
				els: [
					{
						tag: 'div',
						className: 'file_explorer-auth',
						els: [
							{
								tag: 'h1',
								text: 'Groupie drive'
							},
							this._authError = mkE({
								tag: 'p',
								text: 'Authenticating access..'
							})
						]
					}
				]
			}).append(this.node);

			if (this.url.get.v('code')) {
				this._mGet = new DR.web.GetCrazyWolfSubmissions();
				this._mGet.select = [
					new DR.roadgames.select.Image().medium().original(),
					new DR.teams.select.Team().title().id(),
					new DR.events.select.Event().title()
				];
				this._mGet.code = this.url.get.v('code');
				this._mGet.onLoad = this._mGetRe;
				this._mGet.onError = this._mGetError;
				this.apiCall.addMethod(this._mGet);

				this.apiCall.call();
			} else {
				setNodeText(this._authError, 'You don\'t seem to have access to this.');
				this.ready();
			}
		},
		_mGetError() {
			let text = 'Something went wrong.. Try again later.';
			if (this._mGet.error === 'Invalid code') {
				text = 'You don\'t seem to have access to this.';
			}
			setNodeText(this._authError, text);
		},
		_mGetRe() {
			clearNode(this.node);
			let m = this._mGet.re;
			mkE({
				tag: 'div',
				className: 'file_explorer',
				els: [
					{
						tag: 'h1',
						text: `Groupies: ${m.event.title}`
					},
					{
						tag: 'div',
						className: 'file_explorer-menu',
						els: [
							this._inputSelectAll = new T.Form.CheckBox({
								caption: 'Select all',
								onChange: this._onChangeSelectAll
							}),
							this._inputGrouping = new T.Form.Select({
								caption: 'Group',
								onChange: this._onChangeGrouping,
								value: '',
								options: [
									{
										caption: 'Ungrouped',
										value: ''
									},
									{
										caption: 'Teams',
										value: 'teams'
									},
									{
										caption: 'Tasks',
										value: 'tasks'
									}
								]
							}),
							this._inputSelectConsent = new T.Form.CheckBox({
								caption: 'Only with consent',
								onChange: this._onChangeConsent,
								disabled: m.requireConsent,
								checked: m.requireConsent
							}),
							{
								tag: 'div',
								className: 'flex-grow-1'
							},
							this._downloadButton = mkE({
								tag: 'a',
								className: 'button button-pink',
								onclick: this.download,
								text: 'Download all'
							})
						]
					},
					this._pageWindow = mkE({
						tag: 'div',
						className: 'file_explorer-window'
					})
				]
			}).append(this.node);

			for (let i = 0; i < m.items.length; i++) {
				const item = new SectionGroupieDrive.File(m.items[i], this);
				this._items.set(item.id, item);
			}

			this._drawItems();
		},
		_drawItems() {
			clearNode(this._pageWindow);
			const requireConsent = this._inputSelectConsent.value();
			const grouping = this._inputGrouping.value();
			const groups = {};
			this._items.forEach(item => {
				if (requireConsent && !item.hasConsent) {
					//continue;
				} else {
					let groupId = 0;
					if (grouping === 'teams') {
						groupId = item.teamId;
					} else if (grouping === 'tasks') {
						groupId = item.taskId;
					}
					if (!groups[groupId]) {
						groups[groupId] = [];
					}
					groups[groupId].push(item);
				}
			});
			for (let i in groups) {
				let item = groups[i][0];
				let groupTitle = '';
				if (grouping === 'teams') {
					groupTitle = {
						tag: 'h3',
						text: this._mGet.re.teams[item.teamId].title
					};
				} else if (grouping === 'tasks') {
					groupTitle = {
						tag: 'h3',
						text: this._mGet.re.tasks[item.taskId].text
					};
				}
				mkE({
					tag: 'div',
					els: [
						groupTitle,
						{
							tag: 'div',
							className: 'file_explorer-window-files',
							els: [
								groups[i]
							]
						}
					]
				}).append(this._pageWindow);
			}
		},
		_onChangeGrouping() {
			this._drawItems();
		},
		_onChangeSelectAll() {
			let v = Boolean(this._inputSelectAll.value());
			this._items.forEach(item => {
				item.selected(v);
			});
			if (v) {
				let c = this._items.size;
				this._inputSelectAll.caption(`${c} items selected`);
				setNodeText(this._downloadButton, 'Download selected')
			} else {
				this._inputSelectAll.caption(`Select all`);
				setNodeText(this._downloadButton, 'Download all')
			}
		},
		_onChangeConsent() {
			this._drawItems();
		},
		onChangeItemSelect() {
			let c = 0;
			this._items.forEach(item => {
				if (item.isSelected) {
					c++;
				}
			});
			if (c > 0) {
				this._inputSelectAll.caption(`${c} items selected`);
				setNodeText(this._downloadButton, 'Download selected')
				this._inputSelectAll.value(true);
			} else {
				this._inputSelectAll.caption(`Select all`);
				setNodeText(this._downloadButton, 'Download all')
				this._inputSelectAll.value(false);
			}
		},
		download() {
			let ids = [], none = 0;
			this._items.forEach(item => {
				if (item.selected()) {
					ids.push(item.id);
				} else {
					none++;
				}
			});
			if (!none) {
				ids = [];
			}
			let form = mkE({
				tag: 'form',
				method: 'POST',
				action: '/api/groupie_drive.php',
				target: '_blank',
				els: [
					{tag: 'input', name: 'code', value: this._mGet.code},
					{tag: 'input', name: 'consent', value: Number(this._inputSelectConsent.value())},
					{tag: 'input', name: 'group', value: this._inputGrouping.value()},
					{tag: 'input', name: 'ids', value: JSON.stringify(ids)}
				]
			}).append(document.body);
			form.submit();
			form.remove();
		}
	},
	Section
);

/**
 * @class
 * @extends mkE.Base
 */
SectionGroupieDrive.File = Class(
	/**
	 * @lends {SectionGroupieDrive.File#}
	 */
	{
		id: 0,
		isSelected: false,
		/**
		 * @param {DR.web.struct.CrazyWolfSubmission} item
		 * @param {SectionGroupieDrive} parent
		 * */
		__construct: function (item, parent) {
			this.id = item.id;
			this.taskId = item.taskId;
			this.teamId = item.teamId;
			this.hasConsent = item.hasConsent;
			this.parent = parent;
			let inner = null;
			let url = '';
			let ext = '';
			if (item.type === DR.web.struct.CrazyWolfSubmission.TYPE_VIDEO) {
				url = item.video.url;
				ext = '.mp4';
				inner = {
					tag: 'a',
					className: 'noAjax',
					target: '_blank',
					href: url,
					els: [
						{
							tag: 'img',
							src: item.video.thumbnail.medium,
							loading: 'lazy'
						},
						{
							tag: 'span',
							className: 'icon',
							els: [
								D.svgIcon('play')
							]
						}
					]
				};
			} else {
				url = item.image.original;
				ext = '.jpg';
				inner = {
					tag: 'a',
					className: 'noAjax',
					target: '_blank',
					href: url,
					els: [
						{
							tag: 'img',
							loading: 'lazy',
							src: item.image.medium
						}
					]
				};
			}
			this.node = mkE({
				tag: 'div',
				className: 'file_explorer-window-file',
				els: [
					inner,
					{
						tag: 'div',
						className: 'file_explorer-window-file-controls',
						els: [
							this._checked = new T.Form.CheckBox({
								onChange: this._onSelected,
								name: `item[${item.id}]`
							}),
							{
								tag: 'a',
								className: 'noAjax download',
								href: url,
								title: 'Download',
								attr: {
									download: `${item.id}${ext}`
								},
								els: [
									D.svgIcon('share')
								]
							},
							item.hasConsent ? {
								tag: 'span',
								className: 'consent',
								text: 'Consented'
							} : {
								tag: 'span',
								className: 'consent consent--none',
								text: 'No consent'
							}
						]
					}
				]
			});
		},
		_onSelected() {
			this.isSelected = this.selected();
			toggleClassName(this.node, 'file_explorer-window-file--active', this.isSelected);
			this.parent.onChangeItemSelect();
		},
		selected(v = null) {
			if (v !== null) {
				this.isSelected = v;
			}
			return Boolean(this._checked.value(v));
		}
	},
	mkE.Base
);
